import Repository from "../../services/Repository"


const reSource =  '/Galleries';


export default {
    get(data){
        return Repository.post(`${reSource}/list-filtered`, data);
    },
    create(data){
        return Repository.post( `${reSource}/create`, data);
    },
    delete(data){
        return Repository.delete( `${reSource}`+ data);
    },
    edit(data , query){
        return Repository.put( `${reSource}` + query , data);
    },
    getById(data){
        return Repository.get( `${reSource}`+data);
    },
    getComment(data ){
        return Repository.get( `${reSource}/comment` + data);
    },
    approveComment( query){
        return Repository.patch( `${reSource}/comment` + query  );
    },
    getCommentCount( query){
        return Repository.get( `${reSource}/comment/count` + query  );
    },
    getForArragne( query){
        return Repository.get( `${reSource}/priorty/list` + query  );
    },
    submitArragne( body){
        return Repository.patch( `${reSource}/priorty/all` ,body  );
    },
}
